import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'replacepipe',
  standalone: true,
})
export class ReplacePipe implements PipeTransform {
  transform(value: string): string {
    value = value.trim();
    var re = /[^\w]+/gi;
    var newstr = value.replace(re, '_');
    return newstr;
  }
}
